<template>
  <CockpitDialog
    title="响应升级"
    left="630px"
    width="360px"
    height="200px"
    top="120px"
    @close="$emit('close')"
  >
    <el-form ref="form" label-width="80px" :model="formData">
      <el-form-item
        label="响应等级"
        prop="responseLevel"
        :rules="[
          {
            required: true,
            validator: validator,
            message: '请输入正确的响应等级',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-select
          v-model="formData.responseLevel"
          size="small"
          placeholder="请选择响应等级"
          clearable
          popper-class="visualization-select-popper"
        >
          <el-option
            v-for="item in responseLevelList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
            :disabled="item.code <= propData.responseLevel"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="text-center mt-10px flex justify-center">
      <button
        type="button"
        class="handle_btn mr-10px"
        v-loading="formLoading"
        :disable="formLoading"
        @click="save()"
      >
        保存
      </button>
      <button class="handle_btn" type="button" @click="$emit('close')">
        取消
      </button>
    </div>
  </CockpitDialog>
</template>

<script>
import { AccidentEventsResponseDisposeApi } from '@wiz-api/emergency-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const accidentEventsResponseDisposeApi = new AccidentEventsResponseDisposeApi()
const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  name: 'up-level-dialog',
  props: {
    propData: {
      default: '',
    },
  },
  components: {
    CockpitDialog,
  },
  watch: {},
  data() {
    return {
      responseLevelList: [],
      formData: {
        responseLevel: '',
      },
      formLoading: false,
    }
  },
  computed: {},
  methods: {
    validator(rule, value, callback) {
      if (!value) {
        callback(new Error(rule.message))
      }
      if (value <= this.propData.responseLevel) {
        callback(new Error('响应等级不能小于等于当前等级!'))
        return
      }
      callback()
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.formLoading = true
          const [err, res] = await accidentEventsResponseDisposeApi.responseUprade({
            body: {
              id: this.propData.id,
              responseLevel: this.formData.responseLevel,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '响应升级成功',
              type: 'success',
            })
            this.$emit('handleOk', this.formData.responseLevel)
          }
          this.formLoading = false
        }
      })
    },
    async getDataCategory(codeList = [], values = [], vue) {
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const codes = []
        codeList.forEach((item) => {
          codes.push(abpConfigList.setting.values[item])
        })
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes,
          includeDetails: true,
        })
        const codeMap = codes.reduce((pre, code, index) => {
          pre[code] = values[index]
          return pre
        }, {})
        if (!statusError) {
          const [err, res] = await dataCategoryApi.getListByIds({
            ids: statusRes.map((item) => {
              return item.id
            }),
            includeDetails: true,
          })
          if (!err) {
            res.forEach((item) => {
              vue[codeMap[item.code]] = item.dataItems.map((i) => {
                return {
                  value: i.code,
                  label: i.displayName,
                  ...i,
                }
              })
            })
          }
        }
      }
    },
  },
  created() {
    this.formData.responseLevel = this.propData.responseLevel

    this.getDataCategory(
      ['EmergencyManagement.DataCategory.ResponseLevel'],
      ['responseLevelList'],
      this
    )
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.handle_btn[disabled] {
  cursor: no-drop;
}
</style>
